import type { Address } from '@/domain/shared/Address.js';
import type { ShiftDifferential } from '@/domain/shifts/ShiftCalculations.js';
import type { CostCode } from '@/domain/cost-code/CostCode.js';

export type PayStructure = 'hourly' | 'salary' | 'commission';
export type BillingType = 'fixed' | 'retainer' | 'hourly' | 'retainer+hourly';

export interface Workplace extends Address {
  billing_type?: BillingType | null;
  commission_pct?: number | null;
  contract_amount?: number | null;
  contract_description?: string | null;
  contract_period?: string | null;
  cost_codes?: CostCode[] | null;
  created_at?: number; // UTC ms
  default_break_minutes?: number;
  default_hours?: number;
  deleted_at?: number | null; // UTC ms
  ein?: string | null;
  flsa_classification?: string | null;
  hourly_rate?: number | null;
  id: string;
  is_contract: number; // 0 | 1
  is_deleted?: number; // 0 | 1
  ot_daily_hours?: number;
  ot_weekly_hours?: number;
  pay_structure: PayStructure;
  salary_amount?: number | null;
  salary_annual?: number | null;
  salary_period?: string | null;
  shift_differentials?: ShiftDifferential[] | null;
  time_rounding?: string | null;
  updated_at?: number; // UTC ms
  workplace_name: string;
}

export const UNASSIGNED_WORKPLACE_ID = 'wp_unassigned';

export function getWorkplaceName(
  workplaces: Workplace[] | undefined | null,
  entry: { workplace_id?: string } | null | undefined,
): string {
  return workplaces?.find(w => w.id === entry?.workplace_id)?.workplace_name ?? '—';
}
